import "./appRedirect.css";

const MobileAppRedirect = () => {
  return (
    <div className="MainBg">
      <div  className="LogoImageHeader"></div>
      <div className="lottieWrapper">
      <lottie-player src="https://assets10.lottiefiles.com/packages/lf20_FVTclc.json" background="transparent" speed="2" class="lottie" loop autoplay></lottie-player>
      </div>
      <p>Take a deep breath while you wait…</p>
    </div>
  );
};
export default MobileAppRedirect;
